<template>
  <div>
    <b-card v-if="$route.params.id">
      <b-row>
        
        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">№</b>
            <b>#{{ GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.id }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">{{$t('date')}}</b>
            <b>{{ $dayjs(GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.created_at).format("DD.MM.YYYY") }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column align-items-center">
            <b class="mb-25">{{$t('status')}}</b>
            <b-badge
              v-if="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status"
              :variant="GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.color"
            >
              {{ GET_ONE_APPLICATION_FOR_BRIGADE_WORKS.status.name }}
            </b-badge>
          </div>
        </b-col>

      </b-row>
    </b-card>

    <validation-observer ref="materialValidate">
      <b-card>
        <div class="material">
          <div class="d-flex align-items-center justify-content-between">

            <div>
              <h4>{{$t('application_for_works')}}</h4>
              <b-button
                size="sm"
                variant="warning"
                @click="refresh()"
              >
                <feather-icon icon="RefreshCcwIcon" size="16" />
              </b-button>
            </div>




             <div class="d-flex">

              <b-form-group :label="$t('date') + ':'">
                <VueDataPicker
                  class="dark-mod"
                  v-model="work_date"
                />
              </b-form-group>

              <b-form-group :label="$t('place_of_work') + ':'" class="ml-1">
                <v-select
                  v-model="work_place"
                  :get-option-label="(el) => {return el.title[$i18n.locale]}"
                  :reduce="(p) => p.id"
                  style="width: 200px;"
                  :options="GET_PLACE_OF_WORK.results"
                >
                  <!-- @input="onBrigadeSelected()" -->
                  <li slot="list-footer" class="pagination">
                    <button :disabled="!GET_PLACE_OF_WORK.previous" @click="previousPlaceOfWork">
                      {{ $t("prev") }}
                    </button>
                    <button :disabled="!GET_PLACE_OF_WORK.next" @click="nextPlaceOfWork">
                      {{ $t("next") }}
                    </button>
                  </li>
                </v-select>
              </b-form-group>

              <b-form-group :label="$t('brigade') + ':'" class="ml-1">
                <v-select
                  v-model="brigade"
                  label="title"
                  style="width: 200px;"
                  :options="GET_BRIGADE.results"
                  @input="onBrigadeSelected"
                >
                  <li slot="list-footer" class="pagination">
                    <button :disabled="!GET_BRIGADE.previous" @click="previousBridge">
                      {{ $t("prev") }}
                    </button>
                    <button :disabled="!GET_BRIGADE.next" @click="nextBridge">
                      {{ $t("next") }}
                    </button>
                  </li>
                </v-select>
              </b-form-group>



              <b-button variant="primary" class="ml-2" @click="onShowAddWorkModal">
                <feather-icon icon="PlusIcon" size="16" />
                {{$t('add')}}
              </b-button>

            </div>
            
          </div>
          <hr />
        </div>

        <b-table
          :fields="fieldsTable"
          :items="allData.works"
          responsive
          hover
          :empty-text="$t('empty_text')"
          show-empty
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(numeration)="props">
            <span>{{ props.index + 1 }}</span>
          </template>

          <!-- <template #cell(brigade)="props">
            <span v-if="props && props.item && props.item.brigade && props.item.brigade.title">{{ props.item.brigade.title }}</span>
          </template> -->

          <template #cell(work_type_category)="props">
            <span v-if="props.item && props.item.work_type && props.item.work_type.category 
            && props.item.work_type.category.hasOwnProperty('title')">
              {{ props.item.work_type.category.title[$i18n.locale] }}
            </span>
            <span v-if="props.item && props.item.category">{{ props.item.category.title[$i18n.locale] }}</span>
          </template>

          <template #cell(work_type)="props">
            <span>{{ props.item.work_type.title[$i18n.locale] }}</span>
          </template>
        
          <template #cell(unity)="props">
            <span>{{props && props.item && props.item.work_type && props.item.work_type.unity && props.item.work_type.unity.title
               ? props.item.work_type.unity.title : ''}}</span>
            <!-- <span>{{ props && props.item && props.item.unity ? props.item.unity.title : '' }}</span> -->
          </template>

          <template #cell(total_amount)="props">
            <span>{{ props && props.item && props.item.price_for_each && props.item.workload
               ? $_formatPriceMixin(props.item.workload.toString().replace(/,/g, "") * props.item.price_for_each.toString().replace(/,/g, ""))  : '' }}</span>
          </template>

          <template #cell(actions)="props">
            <b-button 
              size="sm" 
              variant="warning"
              class="mt-50 mb-50"
              @click="workEdit(props)"
            >
              <feather-icon icon="EditIcon" size="15" />
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              class="ml-50 mt-50 mb-50"
              @click="removeItem(props)"
            >
              <feather-icon icon="TrashIcon" size="15" />
            </b-button>
          </template>
        </b-table>

        <div class="warehouse mt-2">
          <h4>{{$t('sidebar.warehouse')}}</h4>
          <hr />

          <b-row class="justify-content-between">
            <b-col md="3">
              <b-form-group :label="$t('destination_warehouse')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('destination_warehouse')"
                  rules="required"
                >
                  <v-select
                    v-model="allData.storage"
                    label="title"
                    :options="GET_WAREHOUSE"
                    :reduce="(p) => p.id"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
           
            <b-col md="3">
              <h5>{{$t('total_amount')}}: {{getRowsTotalSum}}</h5>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button class="mr-1" variant="outline-secondary" @click="cancel">
          {{ $t("cancel") }}
        </b-button>

        <b-button
          :variant="$route.params.id ? 'warning' : 'success'"
          :disabled="buttonPressed"
          @click="saveAllActions"
        >
          {{ $t("save") }}
        </b-button>
      </div>
    </validation-observer>

    <fields :works_data="works_data" @onSave="onSave" />
  </div>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@core/utils/validations/validations";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import areYouSure from "@/mixins/areYouSure";
import objective from "@/mixins/objective";
import fields from "./fields.vue";
import useJwt from "@/auth/jwt/useJwt";
import loader from "@/mixins/loader";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import brigade from '@/store/reference/brigade';
import VueDataPicker from '@/components/VueDatePicker.vue'

export default {
  name: "AddMaterial",
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    vSelect,
    BCard,
    BTable,
    fields,
    ValidationObserver,
    ValidationProvider,
    BBadge,
    VueDataPicker,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure, objective, loader, priceFormatMixin],
  data() {
    return {
      required,





      // ===============  PRIMARY_DATA_SECTION START ===============
      brigade: '',
      work_place: '',
      brigadesPage: 1,
      fieldsTable: [
        {
          label: "№",
          key: "numeration",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "brigade",
        //   key: "brigade",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          label: "reference.categoriya",
          key: "work_type_category",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "job_type",
          key: "work_type",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "unit_of_measurement",
          key: "unity",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "price_for_unit_of_measurement",
          key: "price_for_each",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "workload",
          key: "workload",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "total_amount",
          key: "total_amount",
          thClass: "text-center",
          tdClass: "text-center",
        },
         {
          label: "contact.comment",
          key: "created_comment",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],

      allData: {
        works: [],
        storage: null,
        device: {type: "desktop"}
      },

      works_data: {},
      index: null,
      buttonPressed: false,
      work_date: '',
      // ===============  PRIMARY_DATA_SECTION END ===============





    };
  },
  computed: {
    ...mapGetters("obectsWarehouse", ["GET_WAREHOUSE"]),
    ...mapGetters("application", ["GET_APPLICATIONS_MATERIAL_ID", "GET_ONE_APPLICATION_FOR_BRIGADE_WORKS"]),
    ...mapGetters("brigade", [
      "GET_BRIGADE",
      'GET_ONE_BRIGADE'
    ]),
    ...mapGetters('placeOfWork', ['GET_PLACE_OF_WORK']),
    ...mapGetters("characterUnits", ["GET_UNITS"]),
    getRowsTotalSum(){
      let totalSum = 0
      this.allData.works.forEach((elem) => {
        totalSum += elem.workload.toString().replace(/,/g, "") * elem.price_for_each.toString().replace(/,/g, "")
      })

      totalSum = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(totalSum);

      return totalSum
    },
  },
  watch: {
    'allData.works': {
      deep: true,
      handler(newValue){
        
      }
    }
  },

  async mounted() {



    // await this.$_loaderStart();

    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh()
    // ===============  PRIMARY_REQUESTS_SECTION START ===============



  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "CREATE_APPLICATIONS_MATERIAL",
      "FETCH_APPLICATION_FOR_BRIGADE_WORKS",
      "FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS",
      "UPDATE_APPLICATION_MATERIAL",
      "DELETE_MATERIAL_INSIDE"
    ]),
    ...mapActions("obectsWarehouse", ["FETCH_WAREHOUSE"]),
    ...mapActions("brigade", [
      "FETCH_BRIGADE",
      'FETCH_ONE_BRIGADE',
    ]),
    ...mapActions("application", [
      "UPDATE_PUT_APPLICATION_FOR_BRIGADE_WORKS",
      'FETCH_APPLICATION_FOR_BRIGADE_WORKS',
      'CREATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS',
    ]),
    ...mapActions('placeOfWork', ['FETCH_PLACE_OF_WORK', 'DELETE_PLACE_OF_WORK']),
    ...mapActions("characterUnits", ["FETCH_UNITS"]),



    

    async previousBridge() {
      if (this.GET_BRIGADE.previous) {
        this.brigadesPage--;

        await this.FETCH_BRIGADE({ page: this.brigadesPage, pagination: "number" });
      }
    },

    async nextBridge() {
      if (this.GET_BRIGADE.next) {
        this.brigadesPage++;

        await this.FETCH_BRIGADE({ page: this.brigadesPage, pagination: "number" });
      }
    },
    



    async previousPlaceOfWork() {
      if (this.GET_PLACE_OF_WORK.previous) {
        const page = this.GET_PLACE_OF_WORK.previous;

        await this.FETCH_PLACE_OF_WORK({ page: page, pagination: "number" });
      }
    },

    async nextPlaceOfWork() {
      if (this.GET_PLACE_OF_WORK.next) {
        const page = this.GET_PLACE_OF_WORK.next;

        await this.FETCH_PLACE_OF_WORK({ page: page, pagination: "number" });
      }
    },




    // ===============  OTHER_FUNCTIONS_SECTION START ===============
    onShowAddWorkModal() {
      this.works_data = {};
      this.index = null;
      this.$nextTick(() => {
        this.$bvModal.show("modal-field");
      });
    },
    findFirstIndex(){
      let a = ''
      this.allData.works.forEach((elem2, index2) => {
        a = this.allData.works.findIndex((elem, index) => {
            if(elem.good_id.id == elem2.good_id.id){
              return elem
            }
        })
      })
      return a
    },
    findSecondIndex(){
      let a = ''
      this.allData.works.forEach((elem2, index2) => {
        a = this.allData.works.findLastIndex((elem, index) => {
            if(elem.good_id.id == elem2.good_id.id){
              return elem
            }
        })
      })
      return a
    },
    onSave(el) {
      if (typeof this.index === "number") {
        this.allData.works.splice(this.index, 1, el);
      } else {
        this.allData.works.push(el);
      }

      this.allData.works.forEach((elem, index) => {

        let count = 0;
        let firstIndex = '';
        let secondIndex = '';

        // this.allData.works.forEach((elem2, index2) => {
        //   if(elem2.good_id.id == elem.good_id.id){
        //     count++;
        //   }
        // })


        // if(count == 2){
        //   firstIndex = this.findFirstIndex()
        //   secondIndex = this.findSecondIndex()

        //   this.allData.works[firstIndex].count = parseFloat((this.allData.works[firstIndex].count).toString().replace(/,/g, ''))
        //    + parseFloat((this.allData.works[secondIndex].count).toString().replace(/,/g, ''))


        //   this.allData.works[firstIndex].count = parseFloat(this.allData.works[firstIndex].count);
        //   this.allData.works[firstIndex].count = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(this.allData.works[firstIndex].count);
        //   this.allData.works.splice(secondIndex, 1)
        // }
      })
    },
    // ===============  OTHER_FUNCTIONS_SECTION START ===============







    // ===============  REFRESH_SECTION START ===============
    async refresh(){
      const { storage_object } = useJwt.getUserData();

      await this.FETCH_WAREHOUSE({ mini: true, is_object: true });
      await this.FETCH_BRIGADE();

      this.allData.storage = storage_object ?? null;
      if (this.$route.params.id) {
        await this.FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS({id: this.$route.params.id}).then(() => {
            const { work_types, storage, brigade, work_date, work_place } = this.GET_ONE_APPLICATION_FOR_BRIGADE_WORKS;

            this.brigade = brigade
            this.work_date = work_date
            this.work_place = work_place

            this.allData.works = work_types.map(el => ({
              id: el.id,
              brigade: brigade,
              work_type: el.work_type,
              price_for_each: el.price_for_each,
              workload: el.workload,
              created_comment: el.created_comment,
            }));
            this.allData.storage = storage.id;
          });
      }
      await this.FETCH_PLACE_OF_WORK({ pagination: "number" })
      await this.FETCH_UNITS({page_size: 1000})
    },
    // ===============  REFRESH_SECTION END ===============










    // ===============  ON_SUBMIT_SECTION START ===============
    async saveAllActions() {
      this.$refs.materialValidate.validate().then(async success => {
        this.buttonPressed = true
        setTimeout(() => {
          this.buttonPressed = false
        }, 2000)
        if (!success) return;

        let userData = localStorage.getItem('userDataWAREHOUSE') ? localStorage.getItem('userDataWAREHOUSE') : {storage: null}
        // eslint-disable-next-line prefer-const
        let { works, ...rest } = this.allData;
        works = works.map(e => {
          
          let a = {
            work_type_id: e.work_type && e.work_type.id ? e.work_type.id : null,
            id: e.work_type && e.work_type.id ? e.work_type.id : null,
            price_for_each: parseFloat(e.price_for_each.toString().replace(/,/g, '')),
            workload: parseFloat(e.workload.toString().replace(/,/g, '')),
            created_comment: e.created_comment,
            storage: userData.storage,
          }

          if(e.id){
            a.id = e.id
          }
          // if(this.brigade){
          //   a.brigade = this.brigade.id
          // }
          return a
        })
        
        let work_place = null
        console.log(this.work_place)

        if(this.work_place.hasOwnProperty('id')){
          work_place = this.work_place.id
        }else{
          work_place = this.work_place
        }

        const data = {work_types: works, ...rest, brigade: this.brigade.id, work_place: work_place, work_date: this.work_date};
        console.log(data)
        if (this.$route.params.id) {
          await this.UPDATE_PUT_APPLICATION_FOR_BRIGADE_WORKS({
            id: Number(this.$route.params.id),
            ...data,
          }).then(async () => {
            await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS();
            this.$router.push({ name: "applications-works" });
          });
        } else {
          await this.CREATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS(data).then(async () => {
            await this.FETCH_APPLICATION_FOR_BRIGADE_WORKS();
            this.$router.push({ name: "applications-works" });
          });
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============









    // ===============  EDIT_SECTION START ===============
    workEdit(props) {
      this.works_data = props.item;
      this.index = props.index;
      this.$route.params.editMode = true
      this.$nextTick(() => {
        this.$bvModal.show("modal-field");
      });
    },
    // ===============  EDIT_SECTION START ===============








    // ===============  CANCEL_SECTION START ===============
    cancel() {
      this.allData.works = [
        {
          work_types: "",
          good_id: "",
          count: null,
          status: false
        }
      ];
      this.$router.back();
    },
    // ===============  CANCEL_SECTION END ===============









    // ===============  REMOVE_SECTION START ===============
    async removeItem(props) {
      if (props.item.id) {
        this.$_showAreYouSureModal().then(async (val) => {
          if (val) {
            await this.DELETE_MATERIAL_INSIDE(props.item.id)
              .then(() => {
                this.allData.works.splice(props.index, 1);
                this.$_okToast();
              })
              .catch(err => {
                this.$_errToast(err);
              });
          }
        });
      } else {
        this.allData.works.splice(props.index, 1);
      }
    },
    // ===============  REMOVE_SECTION END ===============







    // ===============  ON_BRIGADE_SELECTED START ===============
    async onBrigadeSelected(data) {
      await this.FETCH_ONE_BRIGADE({id: this.brigade.id});
    },
    // ===============  ON_BRIGADE_SELECTED END ===============









  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
